import { useMemo } from 'react'
import { getFirestore } from 'firebase/firestore'
import { useFirebaseApp } from '../FirebaseAppContext'

export function useFirestore() {
  const app = useFirebaseApp()
  return useMemo(() => getFirestore(app), [app])
}
